<dx-popup class="custom-chatbot-popup"
    [wrapperAttr]="{class:'core-bot-popup'}"
    [width]="600"
    [height]="725"
    [showTitle]="true"
    title="{{this.customChatbot?.name}} AI Assistant"
    [shading]="true"
    dragEnabled="true"
    container=".dx-viewport"
    showCloseButton="true"
    [(visible)]="showPopup"
    (onHiding)="onHiding($event)"
    (onContentReady)="onContentReady($event)"
    (onShown)="scrollMessagesToBottom($event)">
    <dxi-toolbar-item
      location="after"
      widget="dxButton"
      toolbar="top"
      locateInMenu="never"
      [options]="{
        icon: 'unselectall',
        hint: 'Open CoreBot popout window',
        onClick: openCoreBotPopout
      }"
    >
    </dxi-toolbar-item>
        <dx-scroll-view width="100%" height="100%" useNative="true">
            <div class="custom-chatbot-disclaimer">
                <div id="chatbot-disclaimer-title" class="disclaimer-message">
                    Click to View AI Technology Disclaimer
                </div>
                <dx-tooltip
                    target="#chatbot-disclaimer-title"
                    showEvent="click"
                    [hideOnOutsideClick]="true"
                    width="300px"
                >
                    <div *dxTemplate="let data = data; of: 'content'"> {{this.customChatbot.name}} {{disclaimerMessage}} </div>
                </dx-tooltip>
                </div>
            <div class="nb-theme-default">
                <corebot-popup-content #chatContent
                    class="custom-chatbot-theme"
                    [messages]="messages" 
                    [sellerName]="sellerName"
                    size="medium">
                </corebot-popup-content>
                <div class="custom-chatbot-chat-form" #chatBotChat id="chatBotChat">
                    <div class="custom-chatbot-message-row">
                        <input #chatBotInput nbInput fullWidth
                            id="chatBotInput"
                            class="custom-chatbot-input"
                            [(ngModel)]="message" 
                            (ngModelChange)="onModelChange($event)"
                            (keyup.enter)="sendMessageChatBot($event)"
                            resize="none"
                            autocomplete="off"
                            [placeholder]="samplePrompt"/>
                        <button
                            nbButton
                            #sendButton
                            (click)="sendMessageChatBot($event)"
                            class="send-button"
                            status="primary">
                            <nb-icon icon="paper-plane-outline" pack="nebular-essentials"></nb-icon>
                        </button> 
                    </div>
                </div>
            </div>
        </dx-scroll-view>
    <dxi-toolbar-item #newConversationButton
        widget="dxButton"
        toolbar="bottom"
        [options]="{
            text: 'New Conversation',
            stylingMode: 'outlined',
            type: 'normal',
            onClick: clearCoreBotConversation
        }">
    </dxi-toolbar-item>
</dx-popup>
